/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharereviewtitle2Inputs */

const en_sharereviewtitle2 = /** @type {(inputs: Sharereviewtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cashback review`)
};

const de_sharereviewtitle2 = /** @type {(inputs: Sharereviewtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cashback-Prüfung`)
};

/**
* | output |
* | --- |
* | "Cashback review" |
*
* @param {Sharereviewtitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const sharereviewtitle2 = /** @type {((inputs?: Sharereviewtitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharereviewtitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharereviewtitle2(inputs)
	return de_sharereviewtitle2(inputs)
});
export { sharereviewtitle2 as "shareReviewTitle" }